<div class="auth-wrapper">
  <mat-card class="auth-card" appearance="outlined">
    <mat-card-content class="auth-content">
      <h1 class="headline">{{ 'resetPassword.headline' | transloco }}</h1>

      @if (!token) {
        <p class="dead-link">{{ 'resetPassword.invalidLink' | transloco }}</p>
        <div class="login-link">
          <a [routerLink]="['/forgot-password']" queryParamsHandling="preserve">{{ 'resetPassword.requestNewLink' | transloco }}</a>
        </div>
      } @else if (resetComplete) {
        <p class="confirmation">{{ 'resetPassword.success' | transloco }}</p>
        <button mat-flat-button color="primary" type="button" (click)="returnToApp()">
          {{ 'resetPassword.returnTo' | transloco }} {{ appName || ('common.signIn' | transloco) }}
        </button>
      } @else {
        <form [formGroup]="resetForm" (ngSubmit)="submit()" novalidate>
          <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <mat-label>{{ 'resetPassword.form.newPasswordLabel' | transloco }}</mat-label>
            <input matInput [type]="hidePassword ? 'password' : 'text'"
                   formControlName="password" autocomplete="new-password"/>
            <button mat-icon-button matSuffix type="button"
                    (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="(hidePassword ? 'common.form.showPassword' : 'common.form.hidePassword') | transloco">
              <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            @if (resetForm.get('password')?.hasError('required') && resetForm.get('password')?.touched) {
              <mat-error>{{ 'common.errors.passwordRequired' | transloco }}</mat-error>
            }
            @if (resetForm.get('password')?.hasError('minlength') && resetForm.get('password')?.touched) {
              <mat-error>{{ 'common.errors.passwordTooShort' | transloco }}</mat-error>
            }
            @if (resetForm.get('password')?.hasError('maxlength') && resetForm.get('password')?.touched) {
              <mat-error>{{ 'resetPassword.errors.passwordTooLong' | transloco }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" subscriptSizing="dynamic">
            <mat-label>{{ 'resetPassword.form.confirmPasswordLabel' | transloco }}</mat-label>
            <input matInput [type]="hideConfirm ? 'password' : 'text'"
                   formControlName="confirmPassword" autocomplete="new-password"/>
            <button mat-icon-button matSuffix type="button"
                    (click)="hideConfirm = !hideConfirm"
                    [attr.aria-label]="(hideConfirm ? 'common.form.showPassword' : 'common.form.hidePassword') | transloco">
              <mat-icon>{{hideConfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            @if (resetForm.get('confirmPassword')?.hasError('required') && resetForm.get('confirmPassword')?.touched) {
              <mat-error>{{ 'resetPassword.errors.confirmRequired' | transloco }}</mat-error>
            }
          </mat-form-field>

          @if (resetForm.hasError('passwordMismatch') && resetForm.get('confirmPassword')?.touched) {
            <p class="mismatch-error" role="alert">{{ 'resetPassword.errors.passwordMismatch' | transloco }}</p>
          }
          @if (error) {
            <p class="error" role="alert">{{ error }}</p>
          }

          <button mat-flat-button color="primary" type="submit"
                  [disabled]="resetForm.invalid || loading">
            @if (loading) {
              {{ 'resetPassword.submit.loading' | transloco }}
            } @else {
              {{ 'resetPassword.submit.idle' | transloco }}
            }
          </button>
        </form>
      }
    </mat-card-content>
  </mat-card>
</div>
